import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { setSelectedAccount, setSelectedAddress, loadAccountSelection } from './account-selection.actions';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AccountSelectionService } from '../account-selection.service';

@Injectable()
export class AccountSelectionEffects {
  constructor(
    private actions$: Actions,
    private acountSelectionService: AccountSelectionService,
  ) {}

  loadAccountSelection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAccountSelection),
      mergeMap(() => {
        let storedAccount: any = this.acountSelectionService.getAccountJson();
        let storedAddress: any = this.acountSelectionService.getAddressJson();

        const actions = [];

        if (storedAccount) {
          storedAccount = JSON.parse(storedAccount);

          actions.push(setSelectedAccount({ displayAccount: storedAccount?.displayName }));
        }

        if (storedAddress) {
          storedAddress = JSON.parse(storedAddress);
          actions.push(setSelectedAddress({ displayAddress: storedAddress?.displayAddress }));
        }
        return actions.length > 0 ? of(...actions) : of();
      }),
    ),
  );
}
